var _ = require('underscore'),
  React = require('react'),
  ReactSlider = require('react-slider'),
  ClassNames = require('classnames'),
  OverlayTrigger = require('react-bootstrap/lib/OverlayTrigger'),
  Popover = require('react-bootstrap/lib/Popover');

var Button = require('./button.jsx'),
  CustomPropTypes = require('./types.jsx'),
  Utils = require('./utils.jsx');

var Volume = React.createClass({
  propTypes: {
    role: React.PropTypes.string.isRequired,
    onChange: React.PropTypes.func,
    volume: React.PropTypes.number,
    className: CustomPropTypes.ClassNameType
  },
  render: function () {
    var className = Utils.ClassNames('player-btn', 'player-btn-volume', this.props.className);

    var volumeBar = (
      <Popover id='volume'>
        <ReactSlider
          value={this.props.volume}
          invert
          orientation='vertical'
          className='player-volume-wrapper'
          handleClassName='player-volume-handler'
          barClassName='player-volume-bar'
          onChange={this.props.onChange || function () {}}
          withBars />
      </Popover>
    );

    var volume = this.props.volume || 0,
      icon = 'volume-up';
    if (volume < 50 && volume > 0) {
      icon = 'volume-down';
    } else if (volume == 0) {
      icon = 'volume-off';
    }

    return (
      <OverlayTrigger role={this.props.role}
        trigger='click'
        placement='top'
        overlay={volumeBar}
        rootClose>
        <Button role={this.props.role}
          className={className}
          icon={icon} />
      </OverlayTrigger>
    );
  }
});

module.exports = Volume;



// WEBPACK FOOTER //
// ./src/app/components/volume.jsx